import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { UserSourcesListSkeleton } from "@/app/user-sources/components/user-sources-list-skeleton";
import { UserSourcesList } from "@/app/user-sources/list";
import {
  userSourcesSearchDefaults,
  userSourcesSearchSchema,
} from "@/app/user-sources/search-params";

function UserSourcesPage() {
  return (
    <Suspense fallback={<UserSourcesListSkeleton />}>
      <UserSourcesList />
    </Suspense>
  );
}

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/user-sources"
)({
  validateSearch: zodValidator(userSourcesSearchSchema),
  search: {
    middlewares: [stripSearchParams(userSourcesSearchDefaults)],
  },
  component: UserSourcesPage,
  loader: () => ({
    crumb: "User sources",
  }),
});
